import React from "react";

export default function FuturePrediction() {
  return (
    <div className="space-y-6">

      <h1 className="text-4xl font-bold">
        Future Prediction
      </h1>

      <div className="rounded-xl border border-white/10 p-8">

        <ul className="space-y-3 text-white/70">

          <li>📅 Tomorrow Prediction</li>

          <li>📅 Weekly Prediction</li>

          <li>📅 Monthly Prediction</li>

          <li>📅 Quarterly Prediction</li>

          <li>📅 Yearly Prediction</li>

          <li>🤖 AI Confidence</li>

          <li>🎯 Expected Return</li>

        </ul>

      </div>

    </div>
  );
}
